const stg = sessionStorage
export const storage = {
  set(name, val) {
    stg.setItem(name, JSON.stringify(val));
  },
  get(name) {
    try {
      return JSON.parse(stg.getItem(name));
    } catch (error) {
      return stg.getItem(name);
    }
  },
  remove(name){
    stg.removeItem(name);
  },
  clear() {
    stg.clear()
  },
  setLocal(name, val) {
    localStorage.setItem(name, JSON.stringify(val))
  },
  getLocal(name) {
    try {
      return JSON.parse(localStorage.getItem(name));
    } catch (error) {
      return localStorage.getItem(name);
    }
  },
  removeLocal(name){
    localStorage.removeItem(name);
  },
}


// WEBPACK FOOTER //
// ./src/utils/storage.js